import { render, staticRenderFns } from "./studies-auto-complete-dropdown.vue?vue&type=template&id=baa0992a&scoped=true&"
import script from "./studies-auto-complete-dropdown.vue?vue&type=script&lang=js&"
export * from "./studies-auto-complete-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./studies-auto-complete-dropdown.vue?vue&type=style&index=0&id=baa0992a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa0992a",
  null
  
)

component.options.__file = "studies-auto-complete-dropdown.vue"
export default component.exports